import getGraphMe from './graphApi';

const graph = {
    me: () => getGraphMe(),    
};

export default graph;
